import React, { Fragment } from 'react'
import { Subject, Dates, Timing } from '@app/components/shared/StateLabel/Label'

import SVG from 'react-inlinesvg'
import tourClocks from '@icons/clocks/default.svg'
import finish from '@icons/finish/default.svg'

export const TourDescription = ({ event }) => {
  return (
    <div className="plate plate--info plate--xl m-0 mt-2">
      <div className="w-flex-layout w-flex-layout--columns">
        <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
          <SVG src={tourClocks} />
          <div className="f--l f--default ml-gutter-m">
            { I18n.t('landing.main_round_desc_1') }
          </div>
        </div>

        <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
          <SVG src={finish} />
          <div className="f--l f--default ml-gutter-m">
            { I18n.t('landing.main_round_desc_2') }
          </div>
        </div>

        {/*

          <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
            <SVG src={finish} />
            <div className="f--l f--default ml-gutter-m">
              { I18n.t('landing.trial_round_desc_1') }
            </div>
          </div>

          <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
            <SVG src={finish} />
            <div className="f--l f--default ml-gutter-m">
              { I18n.t('landing.trial_round_desc_2') }
            </div>
          </div>
        */}
      </div>
    </div>
  )
}

const CurrentTour = ({ event }) => {
  return (
    <section className="section tours-section">
      <Subject event={event} className="f--white" />
      <div className="grid grid--md-2--inline">
        <Dates event={event} iconClassName="f--all-white" className="f--white" />
        <Timing event={event} iconClassName="f--all-white" className="f--white" />
      </div>

      <TourDescription event={event} />
    </section>
  )
}

export default CurrentTour
